import { render, staticRenderFns } from "./SuperSalesAgentList.vue?vue&type=template&id=e56a2044"
import script from "./SuperSalesAgentList.vue?vue&type=script&lang=js"
export * from "./SuperSalesAgentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports